import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ImportExchange, ImportInstrument } from "../Components";
import ImportExpiredContract from "../Components/Import/ImportExpiredContract";

const Import = () => {
  return (
    <>
      <div className="row m-0 p-1">
        <div className="col-lg-6 col-sm-6 col-12 m-0 p-0">
          <div className="row m-0 p-0">
            <div className="col-lg-12 col-12 m-0 p-1">
              <ImportExchange />
            </div>
            <div className="col-lg-12 col-12 m-0 p-1">
              <ImportInstrument />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6 col-12 m-0 p-0">
          <div className="row m-0 p-0">
            <div className="col-lg-12 col-12 m-0 p-1">
              <ImportExpiredContract />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Import;
